import { Box, FormControl, InputLabel, MenuItem } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Select from "@mui/material/Select";
import { useNavigate } from "react-router-dom";
// import { ReactComponent as Cloud } from "../assets/svg/Cloud.svg";
// import { ReactComponent as Takephoto } from "../assets/svg/Takephoto.svg";
// import { Button, Dialog, TextField } from "@mui/material";
// import { ReactComponent as Refresh } from "../assets/svg/refresh.svg";
// import { ReactComponent as Close } from "../assets/svg/Close.svg";
import "../../../Assets/css/kyc.css";
// import { ReactComponent as Successmsg } from "../assets/svg/successmsg.svg";

const VerifyNric = () => {
  const numOfContainers = 6;
  const [open, setOpen] = useState(false);
  const canvasRef = useRef(null); // Create a ref for the canvas
  const [currentCaptcha, setCurrentCaptcha] = useState(""); // Store current CAPTCHA
  const [verifiedOpen, setVerifiedOpen] = useState(false);
  const [showData, setShowData] = useState(true);
  const [nricNumber, setNricNumber] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [display, setDisplay] = useState(true);
  const [documentType, setDocumentType] = React.useState("");
  const navigate = useNavigate();
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      console.log("File selected:", file.name);
      // Additional logic for handling the uploaded file
    }
  };

  const handleNavigation = (event) => {
    const selectedValue = event.target.value;
    setDocumentType(selectedValue);

    // Trigger navigation based on the selected value
    if (selectedValue === 10) {
      navigate("/VerifyNricForm", {
        state: { documentType: selectedValue },
      }); // Navigate to Electricity Bills page
    } else if (selectedValue === 20) {
      navigate("/VerifyNricForm", {
        state: { documentType: selectedValue },
      }); // Navigate to Water Bills page
    } else if (selectedValue === 30) {
      navigate("/VerifyNricForm", {
        state: { documentType: selectedValue },
      }); // Navigate to Gas Bills page
    }
  };

  //   const verifyCaptcha = () => {
  //     const input = document.getElementById("captchaInput").value;
  //     const messageElement = document.getElementById("captchaMessage");

  //     if (input === currentCaptcha) {
  //       messageElement.textContent = "CAPTCHA verified successfully!";
  //       messageElement.style.color = "green";
  //     } else {
  //       messageElement.textContent = "Incorrect CAPTCHA. Please try again.";
  //       messageElement.style.color = "red";
  //     }
  //   };

  const inputRefs = useRef([]); // Create an array of refs for each text field

  const handleInputChange = (e, index) => {
    const value = e.target.value;

    // Validate input: check if it's a number
    if (/^\d$/.test(value)) {
      // If valid, move focus to the next field
      if (index < numOfContainers - 1) {
        inputRefs.current[index + 1].focus();
      }
    } else {
      // If not valid, clear the input
      e.target.value = "";
    }
  };

  const handleClose = () => {
    setOpen(false);
    setShowData(false);
    setVerifiedOpen(false);
  };

  return (
    <div className="Allcards_full_container p-3">
      <div className="m-1 bg-white rounded-2">
        <div
          className="d-flex flex-column justify-content-center align-items-center text-center"
          style={{
            minHeight: "80vh", // Full viewport height
          }}
        >
          <div>
            <div>
              <h2 className="m-0">Verify Your NRIC Identity</h2>
              <p className=" paragraph my-1">
                Upload Your NRIC for Secure Verification
              </p>
            </div>

            <Box>
              <FormControl sx={{ minWidth: 400 }}>
                <InputLabel id="demo-simple-select-label">
                  Select Document type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={documentType}
                  label="Select Document type"
                  onChange={handleNavigation}
                >
                  {/* Placeholder MenuItem */}

                  <MenuItem value={10}>Pink NRIC (Citizen)</MenuItem>
                  <MenuItem value={20}>Orange NRIC (PR)</MenuItem>
                  <MenuItem value={30}>Blue NRIC (EP)</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyNric;
